import { createApp } from "vue";
import AppConfig from "@SoleDiCasa/Scripts/Config/AppConfig";
import { router } from "@SoleDiCasa/Scripts/Config/RouteConfig";
import { store } from "@SoleDiCasa/Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";


export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["CookieToast"]
        });

        const app = createApp({});
        (<any>app).config.devtools = false;

        app.use(router).use(store).use(AppConfig);

        (<any>window).App.instances.vm = app.mount('#app');
    }
}